import { axiosInstance } from "../axiosInstance";
import {
  FetchNotificationTypesRequest,
  FetchNotificationTypesResponse,
} from "./types";

export const fetchNotificationTypes = async (
  requestData: FetchNotificationTypesRequest = {},
): Promise<FetchNotificationTypesResponse> => {
  const params = {
    ...requestData,
  };

  const response = await axiosInstance.get<FetchNotificationTypesResponse>(
    "/api/private/notification-types",
    {
      params,
    },
  );
  return response.data;
};
